import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";

import Entidades from "./Entidades";
import Estudiantes from "./Estudiantes";
import Historico from "./Historico";
import Materias from "./Materias";
import Modalidades from "./Modalidades";
import Preferencias from "./Preferencias";
import RetiroMaterias from "./RetiroMaterias";
import DatosEstadisticos from "../Opciones/DatosEstadisticos";
/* import Profesores from "./Profesores"; */
import Usuarios from "./Usuarios";

import { ConsultaPaices } from "../../funciones/EntidadesFuncion";

class MainRegistros extends Component {
    state = {
        valorRegistro: { value: 'estudiantes', label: 'Estudiantes' },
        paices:[]
    }

    componentWillMount = () => {
        ConsultaPaices ((resp) => {
            this.setState({paices: resp})
        })
    }

    Selecciona = (link) => {
        switch (link) {
            case "/registros/entidades":
                return({ value: 'entidades', label: 'Estados y Entidades' })
            case "/registros/estudiantes":
                return({ value: 'estudiantes', label: 'Estudiantes' })
            case "/registros/historico":
            case "/registros/retiro_materias":
                return({ value: 'retiro_materias', label: 'Retiro de Materias' })
            case "/registros/historico":
                return({ value: 'historico', label: 'Archivo Histórico' })
            case "/registros/materias":
                return({ value: 'materias', label: 'Materias' })
            case "/registros/modalidades":
                return({ value: 'modalidades', label: 'Modalidades' })
            case "/registros/preferencias":
                return({ value: 'preferencias', label: 'Preferencias' })
            case "/registros/estadisticas":
                return({ value: 'estadisticas', label: 'Datos Estadísticos' })
            /* case "/registros/profesores":
                return({ value: 'profesores', label: 'Profesores' }) */
            case "/registros/usuarios":
                return({ value: 'usuarios', label: 'Usuarios' })
            default:
                return({ value: 'entidades', label: 'Estados y Entidades' })
        }
    }

    valorRegistroLabel = (link) => {
        switch (link) {
            case "/registros/entidades": return('Estados y Entidades')
            case "/registros/estudiantes": return('Estudiantes')
            case "/registros/retiro_materias": return('Retiro de Materias')
            case "/registros/historico": return('Archivo Histórico')
            case "/registros/materias": return('Materias' )
            case "/registros/modalidades": return('Modalidades')
            case "/registros/preferencias": return('Preferencias')
            case "/registros/estadisticas": return('Datos Estadísticos')
            /* case "/registros/profesores": return('Profesores') */
            case "/registros/usuarios": return('Usuarios')
            default: return('Estados y Entidades')
        }
    }


    valorSelectRegistro = (valorRegistro) => {
        this.setState({
            valorRegistro
        },() => {
            this.props.history.push(`/registros/${this.state.valorRegistro.value}`);
        });
    }
    
    contenido = () => {
        let {paices} = this.state;
        
        return (
            <Switch>
                <Route path="/registros/entidades" component={ () => <Entidades paices = {paices}/> } />
                <Route path="/registros/estudiantes" component={ () => <Estudiantes/> } />
                <Route path="/registros/retiro_materias" component={ () => <RetiroMaterias/> } />
                <Route path="/registros/historico" component={ () => <Historico/> } />
                <Route path="/registros/materias" component={ () => <Materias/> } />
                <Route path="/registros/modalidades" component={ () => <Modalidades/> } />
                <Route path="/registros/preferencias" component={ () => <Preferencias/> } />
                <Route path="/registros/estadisticas" component={ () => <DatosEstadisticos/> } />
                {/* <Route path="/registros/profesores" component={ () => <Profesores/> } /> */}
                <Route path="/registros/usuarios" component={ () => <Usuarios/> } />
                <Redirect to = "/registros/entidades" />
            </Switch>
        )
    }

    render() {
        const Registros = [
            { value: 'entidades', label: 'Estados y Entidades' },
            { value: 'estudiantes', label: 'Estudiantes' },
            { value: 'retiro_materias', label: 'Retiro de Materias' },
            { value: 'historico', label: 'Archivo Histórico' },
            { value: 'materias', label: 'Materias' },
            { value: 'modalidades', label: 'Modalidades' },
            { value: 'preferencias', label: 'Preferencias' },
            /* { value: 'estadisticas', label: 'Datos Estadísticos' }, */
            /* { value: 'profesores', label: 'Profesores' }, */
            { value: 'usuarios', label: 'Usuarios' },
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <div className="custom-alert-info" style={{marginBottom:15, padding:5}}>
                        <Row>
                            <Col md={9}>
                                <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                    Selecciona el tipo de Registro
                                </div>
                            </Col>
                            <Col md={3}>
                                <Select
                                    isSearchable ={true}
                                    value={this.Selecciona(this.props.history.location.pathname)}
                                    onChange={this.valorSelectRegistro}
                                    options={Registros}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <CustomCard
                                title={`Opciones de ${this.valorRegistroLabel(this.props.history.location.pathname)}`}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
 
export default MainRegistros;


// WEBPACK FOOTER //
// ./src/views/Registros/MainRegistros.jsx